import {
  CarouselControls,
  CarouselNavigation,
  CarouselPagination,
  CarouselSlide,
  Carousel as DSCarousel,
} from '@cinch-labs/design-system'
import cx from 'classnames'

import styles from './why-cinch-carousel.module.css'
import { StoryBlockTitleAndText } from '../../../types/store-page'
import { WhyBuyContentCard } from '..'
import { tagError } from '@core/datadog-server'

interface CarouselProps {
  content: StoryBlockTitleAndText[]
  carouselName: string
}

function chunkArray<T>(arr: T[], size: number) {
  return Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
    arr.slice(i * size, i * size + size),
  )
}

export const WhyCinchCarousel = ({ content, carouselName }: CarouselProps) => {
  const navAriaLabels = {
    previous: 'Go to previous slide',
    next: 'Go to next slide',
  }
  const groupSize = 2
  let groupedCards: StoryBlockTitleAndText[][] = []

  try {
    groupedCards = chunkArray<StoryBlockTitleAndText>(content, groupSize)
  } catch (error) {
    if (error instanceof Error || typeof error === 'string') {
      tagError(error)
    }
    groupedCards = []
  }
  return (
    <>
      <DSCarousel
        name={carouselName}
        swiperSettings={{
          slidesPerView: 1,
          spaceBetween: 16,
          breakpoints: {
            564: {
              slidesPerView: 1,
            },
          },
        }}
        ariaLabel={`${carouselName}-carousel`}
      >
        {groupedCards.map((group, index) => (
          <CarouselSlide key={`group-${index}`}>
            <div className={styles.groupedCardWrapper}>
              {group.map((content) => (
                <WhyBuyContentCard key={`${content.title}`} content={content} />
              ))}
            </div>
          </CarouselSlide>
        ))}
      </DSCarousel>
      <CarouselControls customClassNames={styles.controlsWrapper}>
        <CarouselPagination
          name={carouselName}
          customClassNames={cx(
            `${carouselName}-pagination`,
            styles.pagination,
            styles.customPagination,
          )}
          data-testid="ds-carousel-pagination"
          aria-hidden="true"
        />
        <CarouselNavigation
          name={carouselName}
          ariaLabels={navAriaLabels}
          aria-hidden={true}
          customClassNames={{
            prevButton: styles.prevButton,
            nextButton: styles.nextButton,
          }}
        />
      </CarouselControls>
    </>
  )
}
